import styled from 'styled-components';

const Wrapper = styled.div<{
	isBorder: boolean;
	size: number;
	isShadow: boolean;
}>`
	display: flex;
	border-radius: ${p => (p.size ? p.size : 0)}px;
	border: ${p => (p.isBorder ? 2.1 : 0)}px solid #ffffff;
	filter: ${p =>
		p.isShadow
			? 'drop-shadow(0px 4.2px 4.2px rgba(20, 18, 31, 0.25))'
			: 'none'};
`;

// eslint-disable-next-line import/no-anonymous-default-export
export default {
	Wrapper,
};
